/*
 *
 * ConnectionManager reducer
 *
 */

import { fromJS } from 'immutable';
import * as constants from './constants';

const initialState = {
  loading: false,
  error: undefined,
  connected: false,
};

function connectionManagerReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.CONNECT:
      return state
        .set('loading', action.auth.bearerToken ? 'AUTO_CONNECTING' : true)
        .set('error', undefined)
        .set('connected', false);
    case constants.CONNECT_SUCCESS:
      return state
        .set('loading', false)
        .set('error', undefined)
        .set('connected', true);
    case constants.CONNECT_ERROR:
      return state
        .set('loading', false)
        .set('error', action.error)
        .set('connected', false);
    case constants.DISCONNECT:
      return state
        .set('loading', false)
        .set('error', undefined)
        .set('connected', false);
    default:
      return state;
  }
}

export {
  initialState,
};

export default connectionManagerReducer;
